import React,{useState,useEffect} from 'react';
import '../Css/ImageGallery.css';
import axios from 'axios';
import photoIcon from '../icon/icons8-photo-gallery-80.png';
import Promote5 from '../Image/Promote5.png';

function PhotoGallery() {
     useEffect(() => {
        let data =[];
        axios.get("https://www.pta-hk.com/getGallery.php").then
        (response=>{
            data = response.data;
            setImages(data);
            console.log("Image Data:",data);
        }).catch((e)=>console.log(e));
    }, []);

    /*
    const imageUrls = [
      'https://www.pta-hk.com/gallery/image1.jpg',
      'https://www.pta-hk.com/gallery/image2.jpg',
      'https://www.pta-hk.com/gallery/image3.jpg',
      'https://www.pta-hk.com/gallery/image4.jpg',
      'https://www.pta-hk.com/gallery/image5.jpg',
      'https://www.pta-hk.com/gallery/image6.jpg',
      'https://www.pta-hk.com/gallery/image7.jpg',
      'https://www.pta-hk.com/gallery/image8.jpg',
      'https://www.pta-hk.com/gallery/image9.jpg',
      'https://www.pta-hk.com/gallery/image10.jpg',
    ];
    */

    const [images, setImages] = useState([]);

    //set state for image select ,store the url for selected image
    const [selectedImage, setSelectedImage] = useState(null);
   
    

    const openModal = (imgUrl) => {
      setSelectedImage(imgUrl);
    };

    const closeModal = () => {
      setSelectedImage(null);
    };

      
  return (
    <div className="container"> 
       <div className="banner-section">
        <a
          href="https://www.pta-hk.com/#/sponsor" 
          target="_blank"
          rel="nopener noreferrer"
          arial-label="Event"
        >
          <img src={ Promote5 }
            alt="Poker Tournament Association"
            className="bannerImage1"
          />
        </a>
        </div>

      <div classNam="container-content">
        <div className="gallery-container">
          <div className="title">
          <h2>比賽實況 &nbsp;&nbsp;
          <img src={photoIcon}
            alt="Poker Tournament Association"
            className="icon"
          />
          </h2>
          </div>
          
          <div className="image-content">
          
            <div className="image-grid">
            {/*** loading all image in grid *****/}
            {images.map((imgUrl, index)  => (
              <div key={index} className="image-item" onClick={() => openModal(imgUrl)}>
                <img 
                  src={imgUrl} 
                  alt={`Gallery item ${index + 1}`}
                  loading="lazy" // For better performance
                />
              </div>
            ))}
            </div>

            {selectedImage && (
              <div className="modal" onClick={closeModal}>
                <span className="close-btn">&times;</span>
                <img className="modal-content" src={selectedImage} alt="Enlarged view" />
              </div>
            )}
          </div>
      </div>  
      </div>
    </div>    
  )
}

export default PhotoGallery
